<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;display: flex;justify-content: flex-end;">
          <el-tooltip class="item" effect="dark" content="手上已经有表格,制表有点麻烦,直接导入吧" placement="bottom">
          <el-button type="primary" @click="importDataExcel()">导入包含数据的Excel</el-button>
          </el-tooltip>
        </div>

        <div style="padding: 10px;">
          <el-table border :data="tableData" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="form_name" label="表格名称">
            </el-table-column>

            <el-table-column prop="state" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.state===1" style="color: red">未发放</span>
                <span v-if="scope.row.state===2" style="color: royalblue">正在填写</span>
                <span v-if="scope.row.state===100" style="color: green">已收回</span>
              </template>
            </el-table-column>
            <el-table-column prop="submit_count" label="已填(条)" align="center" width="100">
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" align="center" width="180">
            </el-table-column>
            <el-table-column prop="input_pages" :formatter="convertPages" label="填写张数" width="80" header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="file_type" label="下载格式" width="80" header-align="center" align="center">
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div class="actionStyle">
                  <div>
                    <el-button @click.native.prevent="sendForm(scope.$index, tableData)" type="text" size="small">
                      <div style="color: red;" v-if="tableData[scope.$index].state!='2'">发放表格</div>
                      <div style="" v-else>发放表格</div>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="deleteForm(scope.$index, tableData)" type="text" size="small">
                      删除表格
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="tackbackForm(scope.$index, tableData)" type="text" size="small">
                      收回表格
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="browseData(scope.$index, tableData)" type="text" size="small">
                      浏览数据
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="exportToFile(scope.$index, tableData)" type="text" size="small">
                      导出{{tableData[scope.$index].file_type}}
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="exportToPDF(scope.$index, tableData)" type="text" size="small">
                      导出PDF
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delFormContentRecord">删 除</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--Excel文件下载-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="下载Excel文件" :visible.sync="downloadExcelDialogVisible">
      <el-form>
        <div>
          <div>
            Excel文件已经生成,请点下载按钮下载。
          </div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadExcel">下 载</el-button>
        <el-button @click="downloadExcelDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!--Zip文件下载-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="下载压缩包文件" :visible.sync="downloadZipDialogVisible">
      <el-form>
        <div>
          <div>
            压缩包文件已经生成,请点下载按钮下载。下载后用解压工具打开。
          </div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadZip">下 载</el-button>
        <el-button @click="downloadZipDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!--PDF文件下载-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="下载PDF文件" :visible.sync="downloadPDFDialogVisible">
      <el-form>
        <div>
          <div>
            PDF文件已经生成,请点下载按钮下载。
          </div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadPDF">下 载</el-button>
        <el-button @click="downloadPDFDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!--发放表格窗口-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="发放表格" :visible.sync="sendFormDialogVisible">
      <el-form>
        <div>
          <div>
            发放表格需要在手机的操作,请用微信扫描下面的二维码打开多人填表小程序,在“更多功能”连接电脑后发放表格。
          </div>
          <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
            <img src="../assets/duorentianbiao-wx.jpg" style="width: 200px;height: 200px;" />
            <div>
              <div style="font-weight: bold;">操作步骤:</div>
              <div>1.用微信扫上面的码打开多人填表;</div>
              <div>2.如果没有连接电脑,在手机上多人填表右下角点击“更多功能”,再点“电脑互联”按照提示连接;如已经连接跳过本步骤;</div>
              <div>3.在手机多人填表小程序下边点“发出的表”找到《{{selected_form_name}}》并点击;</div>
              <div>4.点表格下面的“点我发放”或“点我重发”发送给填表人或群中即可.</div>
            </div>
          </div>

        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendFormDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,

        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',

        downloadPDFDialogVisible: false

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_forms.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.tableData = response.data
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state

        if (typeof (state) === 'undefined' || state === 1) {
          return '未发放'
        }

        if (state === 2) {
          return '正在填写'
        }

        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages

        if (typeof (inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }

        if (inputPages > 1) {
          return '多张/人'
        }
      },

      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id

        var state = rows[index].state

        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！', '提示', {

            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })
          // this.$message.error('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！')

          return
        }

        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,导出可备份数据。如已备份且确实需要删除,请点"删除",否则请点击"取消"!'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }

        this.dialogVisible = true
      },
      delFormContentRecord() {
        let that = this
        this.dialogVisible = false

        // 调用删除接口
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            // that.loadDateList()

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      tackbackForm(index, rows) {
        let that = this
        this.position = index
        this.selected_form_id = rows[index].id

        this.msg = '收回表格会停止填写表格,尚未填写的将不能继续填写,如要填写需要重新发放,要收回表格吗?'

        that.$confirm(this.msg, '操作提示', {
          confirmButtonText: '全部收回',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 收回表格
          var requestUrl = '/form/web/_tack_back_form.jsp'
          that.axios.get(requestUrl, {
              params: {
                form_id: that.selected_form_id
              }
            }).then(function(response) {
              // that.loadDateList()
              that.loadData()

              that.$message.success('收回成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importDataExcel() {
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = ''

        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            // that.current_download_file_name = fileName
            // that.current_download_file_name = response.data.download_file_path
            that.current_download_file_name = fileName
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_export_to_pdf.jsp'

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true

          that.current_download_file_name = response.data.pdf_filename

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadZip() {
        this.downloadZipDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.sendFormDialogVisible = true
      },
      browseData(index, rows) {
        var formId = rows[index].id
        var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        window.open(url)
      },
      openMakeForm() {
        this.$router.push('/make_form')
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/validation_form_list.vue